import Model from './BaseModel'

export default class Bank extends Model {
    resourceName() {
        return 'banks'
    }

    fields() {
        return ['id', 'code', 'name']
    }

    get searchable() {
        return ['search']
    }
}
